import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./Assets/css/Style.css"
import "./Assets/css/FontAwesome/Css/all.min.css"
import "./Assets/css/FontAwesome/Css/fontawesome.min.css"
import 'cropperjs/dist/cropper.min.css'
import 'react-loading-skeleton/dist/skeleton.css'
import "./Assets/css/Dashboard.css"
import "./Assets/css/Profile.css"
import "./Assets/css/Scan.css"
import "./Assets/css/Article.css"
import "./Assets/css/Campaign.css"
import "./Assets/css/Documents.css"
import "./Assets/css/BPCalibration.css"
import "./Assets/css/Languageselector.css"
import "./Components/Header.css"
import "./Styles/FaceScanning.css"
import "./Styles/ScanResults.css"
import { SkeletonTheme } from 'react-loading-skeleton';
import AppRouter from './Router/Route';
import Toast from './Components/Toast';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { useLocation } from 'react-router-dom';
import storage from './Assets/js/Global';
import { useEffect } from 'react';

// Initialize window.showToast as a no-op to prevent crashes if called before Toast mounts
window.showToast = (type, message) => {
  console.log(`Toast (${type}): ${message}`);
};

const App = () => {
  const location = useLocation();
  const authRoutes = [
    '/',
    '/login',
    '/login-v2',
    '/password',
    '/forgot-password',
    '/verify-otp',
    '/signup/wellness-interests',
    '/reset-password',
    '/biometric-required',
    '/delete-account',
    '/signup/account-details',
    '/signup/physical-profile',
    '/signup/lifestyle',
    '/signup/wellness-priorities',
    '/qr-scanner',
    '/web-face-scan',
    '/bp-calibration',
    // '/plan-expired'
  ];

  if (
    location.pathname !== "/history" &&
    location.pathname !== "/user-scan-details"
  ) {
    storage.remove("lastSelectedDate");
  }
  useEffect(() => {
    const companyId = process.env.REACT_APP_COMPANY_ID;
    const title = companyId === '0it02f' ? "Healthy 4Life AI" : companyId === '5tf4hl' ? "More Active" : "GlobalHealth Check AI";
    const description = companyId === '0it02f' ? "Healthy 4Life AI" : "GlobalHealth Check AI App is an innovative easy-to-use wellness tool.";

    document.title = title;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    const favicon = companyId === '0it02f' ? "favicon4life.ico" : companyId === '5tf4hl' ? "ma_logo.png" : "favicon.ico";
    const faviconLink = document.querySelector('link[rel="icon"]');
    if (faviconLink) {
      faviconLink.setAttribute('href', `%PUBLIC_URL%/${favicon}`.replace('%PUBLIC_URL%', process.env.PUBLIC_URL || ''));
    }

    const appleTouchIcons = document.querySelectorAll('link[rel="apple-touch-icon"]');
    appleTouchIcons.forEach(icon => {
      icon.setAttribute('href', `%PUBLIC_URL%/${favicon}`.replace('%PUBLIC_URL%', process.env.PUBLIC_URL || ''));
    });

  }, []);

  const hideHeaderFooter =
    authRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/scan/') ||
    location.pathname.startsWith('/invite/') ||
    location.pathname.startsWith('/invite-language/');
  return (
    <SkeletonTheme baseColor="#e9eef3" highlightColor="#f5f8fb" borderRadius={8}>
      <Toast />
      {!hideHeaderFooter && <Header />}
      <div
        className={!hideHeaderFooter ? "main-content-with-sidebar" : ""}
      >
        <AppRouter />
      </div>
      {/* {!hideHeaderFooter && <div className="d-lg-none"><Footer /></div>} */}
    </SkeletonTheme>
  )
}

export default App;